import React from 'react';

const ProductDisplay = ({ product, capsules, submitButton = null }) => {
    if (!product) return null;

    return (
        <div className="p-4 w-fit rounded-lg border border-solid border-gray-300 container shadow-sm flex flex-col">
            <div className="flex items-center space-x-4">
                <img src={product.imageUrl} alt={product.name} className="w-12 h-12 object-cover rounded" />
                <div className='relative'>
                    <h2 className="text-lg font-semibold">{product.name}</h2>
                    <p className="text-sm ">Prix : {product.price} €</p>
                    <p className="text-sm ">Quantité : {capsules.length}</p>
                    <p className="text-sm ">Capsules : <span className="font-bold">{capsules.map(capsule => capsule.name).join(", ")}</span></p>
                    {
                        submitButton && (
                            <div className='absolute right-0 bottom-0'>
                                {submitButton}
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default ProductDisplay;
